import React, { useEffect, useMemo, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models, Report } from 'powerbi-client';

import { Box, Paper, Typography, useTheme } from '@mui/material';

interface HelpdeskView {}

export default function HelpdeskView() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ p: 2 }}>Em desenvolvimento</Paper>
        <iframe
          title="Ocupação da Fabrica"
          style={{
            height: 'calc(100vh - 222px)',
          }}
          src="https://app.powerbi.com/reportEmbed?reportId=df07fe92-adff-4d8a-b507-61af467ea90a&autoAuth=true&ctid=4dab0ccf-97e5-48ab-80c6-39d620e7acec"
          frameBorder="0"
          allowFullScreen
        />
      </Box>
    </Box>
  );
}
/*
        <MarkdownEditor.Markdown
            source={formState.description}
            style={{ whiteSpace: 'pre-wrap', backgroundColor: 'transparent' }}
          />
*/
